import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { FaBars, FaTimes } from "react-icons/fa";

import "../styles/Navbar.css";
import logo from "../assets/grownexlogo.svg";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="logo">
        <Link to="/">
          <img src={logo} alt="Grownex Logo" />
        </Link>
      </div>

      {/* Desktop Navigation */}
      <ul className="nav-links">
        <li>
          <NavLink to="/">Home</NavLink>
        </li>

        <li>
          <NavLink to="/about">About Us</NavLink>
        </li>

        <li>
          <NavLink to="/work">Work</NavLink>
        </li>

        <li>
          <HashLink smooth to="/#services">
            Services
          </HashLink>
        </li>

        <li>
          <NavLink to="/insights">Insights</NavLink>
        </li>
      </ul>

      {/* Desktop Button */}
      <Link to="/contact">
        <button className="contact-btn">Get In Touch</button>
      </Link>

      {/* Mobile Menu Icon */}
      <div
        className="menu-icon"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${menuOpen ? "active" : ""}`}>
        <ul>
          <li onClick={closeMenu}>
            <NavLink to="/">Home</NavLink>
          </li>

          <li onClick={closeMenu}>
            <NavLink to="/about">About Us</NavLink>
          </li>

          <li onClick={closeMenu}>
            <NavLink to="/work">Work</NavLink>
          </li>

          <li onClick={closeMenu}>
            <HashLink smooth to="/#services">
              Services
            </HashLink>
          </li>

          <li onClick={closeMenu}>
            <NavLink to="/insights">Insights</NavLink>
          </li>
        </ul>

        <Link to="/contact" onClick={closeMenu}>
          <button className="mobile-btn">
            Get In Touch
          </button>
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;